import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  showRateLimitBanner: false,
};

const rateLimitSlice = createSlice({
  name: 'rateLimit',
  initialState,
  reducers: {
    setShowRateLimitBanner: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showRateLimitBanner: action.payload,
    }),
  },
});

export const { setShowRateLimitBanner } = rateLimitSlice.actions;
export default rateLimitSlice.reducer;
